/**
 * RandomFlower Part
 * Randomizes flower field colors at runtime
 */

import { Part } from '../Part';
import { Events } from '../types';
import { Render } from './Render';
import { random } from '@/utils/Random';

// Available flower colors (from Qud's RandomFlower.cs)
const FLOWER_COLORS = ['R', 'M', 'B', 'C', 'Y', 'G', 'W', 'r', 'm', 'b', 'c', 'y', 'g', 'w'];

/**
 * RandomFlower part
 * On object creation, randomizes the foreground color
 * to one of the flower colors
 */
export class RandomFlower extends Part {
  readonly name = 'RandomFlower';

  onEvent(event: string, _data?: unknown): boolean {
    if (event === Events.OBJECT_CREATED) {
      this.setupFlower();
    }
    return true;
  }

  private setupFlower(): void {
    const render = this.parent?.getPart<Render>('Render');
    if (!render) return;

    // Pick a random flower color
    const flowerColor = random.choice(FLOWER_COLORS);

    // Update the color string with new foreground
    const colors = render.getColors();
    render.colorString = `&${flowerColor}${colors.background ? `^${colors.background}` : ''}`;
  }
}

/**
 * Factory for creating RandomFlower parts
 */
export function createRandomFlower(_params: Record<string, unknown>): RandomFlower {
  return new RandomFlower();
}
